import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qr-form"
}
const _hoisted_2 = { class: "popup__content" }
const _hoisted_3 = { class: "qr-form__step" }
const _hoisted_4 = { class: "qr-form__qr" }
const _hoisted_5 = { class: "qr-form__code" }
const _hoisted_6 = { class: "for-copy" }
const _hoisted_7 = { class: "qr-form__step" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "popup__controls" }
const _hoisted_10 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup--qr",
    title: _ctx.$t('labels.2fa'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      (_ctx.tfaResponse)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[3] || (_cache[3] = _createElementVNode("span", null, " 1 ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.2fa_step_1')), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_vue_qrcode, {
                  value: _ctx.tfaResponse.qr,
                  tag: "svg",
                  options: { width: '300px' }
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.tfaResponse.secret), 1),
                _createVNode(_component_CopyButton, {
                  value: _ctx.tfaResponse.secret
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("span", null, " 2 ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.2fa_step_2')), 1)
              ]),
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.helper.getErrors('2fa', `code`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.$refs.acceptBtn.handleClick(), ["enter"])),
                    "data-maska": "999 999",
                    "data-maska-tokens": "9:[0-9]",
                    class: _normalizeClass(["form-control", parentProps.class]),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tfaResponse.code) = $event)),
                    placeholder: _ctx.$t('labels.2fa_enter_code')
                  }, null, 42, _hoisted_8), [
                    [_directive_maska],
                    [_vModelText, _ctx.tfaResponse.code]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "btn popup__close text-capitalize-first",
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.hide()), ["prevent"]))
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('button.cancel')), 1)
              ]),
              _createVNode(_component_LoaderButton, {
                ref: "acceptBtn",
                class: "btn btn--accept",
                "on-click": _ctx.enable2faConfirm
              }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("svg", {
                    width: "12",
                    height: "10",
                    viewBox: "0 0 12 10",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M11.2044 1.6485L4.74285 9.34081C4.67197 9.42524 4.58377 9.49344 4.48423 9.5408C4.3847 9.58817 4.27614 9.61358 4.16592 9.61533H4.15294C4.04512 9.61529 3.93852 9.59259 3.84004 9.54869C3.74156 9.5048 3.65341 9.44069 3.58131 9.36052L0.812078 6.2836C0.741749 6.20901 0.68704 6.12111 0.651168 6.02507C0.615295 5.92903 0.598982 5.82679 0.603186 5.72436C0.607391 5.62193 0.632028 5.52137 0.675651 5.42859C0.719274 5.33581 0.781003 5.2527 0.857208 5.18412C0.933414 5.11554 1.02256 5.06289 1.1194 5.02925C1.21625 4.99562 1.31884 4.98168 1.42115 4.98826C1.52346 4.99484 1.62342 5.02181 1.71515 5.06757C1.80689 5.11334 1.88856 5.17698 1.95535 5.25475L4.13275 7.67399L10.0265 0.659081C10.1587 0.506234 10.3457 0.411551 10.5472 0.395499C10.7486 0.379446 10.9483 0.443313 11.1031 0.573295C11.2578 0.703277 11.3552 0.888932 11.3741 1.09013C11.3931 1.29133 11.3321 1.4919 11.2044 1.6485Z",
                      fill: "#F7F9FC"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.2fa_verify')), 1)
                ]),
                _: 1,
                __: [5]
              }, 8, ["on-click"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}